import * as SpringRoll from "springroll";
import { CaptionToken } from "../Data/CaptionToken";
import * as Topics from "../Data/Topics";
import { BaseCaptionRenderer } from "../GameObjects/BaseCaptionRenderer";

export class CaptionManager extends PIXI.Container {
    private _active: boolean;
    private _data: any;
    private _player: SpringRoll.CaptionPlayer | undefined;
    private _renderer: BaseCaptionRenderer | undefined;

    constructor(pData: any) {
        super();
        this._active = true;
        this._data = pData;

        PubSub.subscribe(Topics.PLAY_CAPTION, this.onPlayCaptionRequested.bind(this));
        PubSub.subscribe(Topics.STOP_CAPTION, this.onStopCaptionRequested.bind(this));
    }

    public setRenderer(pRenderer: BaseCaptionRenderer): void {
        if (this._renderer !== undefined) {
            this.removeChild(this._renderer);
        }
        this._renderer = pRenderer;
        this._renderer.visible = this._active;
        this.addChild(this._renderer);
        if (this._player === undefined) {
            this._player = new SpringRoll.CaptionPlayer(this._data, this._renderer);
        }
        else {
            this._player.renderer = this._renderer;
        }
    }

    public get active(): boolean {
        return this._active;
    }

    public set active(pValue: boolean) {
        this._active = pValue;
        if (this._renderer !== undefined) {
            this._renderer.visible = this._active;
        }
    }

    public update(pDelta: number): void {
        if (this._player !== undefined && this._active === true) {
            this._player.update(pDelta);
        }
    }

    public playCaption(pId: string, pStart: number = 0, pArgs?: any): void {
        if (this._player !== undefined) {
            this._player.start(pId, pStart, pArgs);
        }
    }

    public stopCaption(): void {
        if (this._player !== undefined) {
            this._player.stop();
        }
    }

    public onResize(pSize: PIXI.Point): void {
        if (this._renderer !== undefined) {
            this._renderer.onResize(pSize);
        }
    }

    private onPlayCaptionRequested(pTopic: string, pToken: CaptionToken): void {
        this.playCaption(pToken.id, pToken.start, pToken.args);
    }

    private onStopCaptionRequested(pTopic: string, pToken: CaptionToken): void {
        this.stopCaption();
    }
}
